















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class StrongKidsCard extends Vue {
  @Prop({ default: () => ({}) }) value!: any;

  localVal: any = this.initVal();

  initVal() {
    return {
      tampak_kurus: false,
      penurunan_bb: false,
      diare_muntah_asupan_kurang: false,
      penyakit_risiko_malnutrisi: false,
      skor_total: 0,
      kategori: 'rendah',
      ...(this.value || {})
    };
  }

  @Watch('value', { deep: true })
  onValueChange() {
    this.localVal = this.initVal();
  }

  recalculate() {
    // Item 4 (penyakit risiko malnutrisi) berbobot 2 — STRONGkids standar (Hulst 2010), skor maks 5.
    const s = (this.localVal.tampak_kurus ? 1 : 0)
      + (this.localVal.penurunan_bb ? 1 : 0)
      + (this.localVal.diare_muntah_asupan_kurang ? 1 : 0)
      + (this.localVal.penyakit_risiko_malnutrisi ? 2 : 0);
    this.localVal.skor_total = s;
    this.localVal.kategori = s === 0 ? 'rendah' : s <= 3 ? 'sedang' : 'berat';
    this.$emit('input', { ...this.localVal });
  }

  get chipColor() {
    const k = this.localVal.kategori;
    return k === 'rendah' ? 'green' : k === 'sedang' ? 'orange' : 'red';
  }

  get chipLabel() {
    const k = this.localVal.kategori;
    return k === 'rendah' ? 'Risiko Rendah' : k === 'sedang' ? 'Risiko Sedang' : 'Risiko Berat';
  }
}
